export function isDevMode(): boolean {
  if (process.env.NODE_ENV === 'development') return true

  if (typeof window !== 'undefined') {
    if (window.localStorage.getItem('onl_dev_mode') === 'true') return true
  }

  return false
}

export function enableDevMode() {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('onl_dev_mode', 'true')
  }
}

export function setDevModeEnabled(enabled: boolean) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem('onl_dev_mode', enabled ? 'true' : 'false')
  // Notify same-tab listeners immediately (storage event won't fire in same tab)
  window.dispatchEvent(new Event('onl_dev_mode_change'))
}
